class LocalStorageService {
    public static readonly FASTLANE_PERSON_DETAILS = 'fastlane_person-details'

    public static async getItem<T>(keyName: string): Promise<T | null> {
        if (typeof window === 'undefined') {
            return null
        }
        try {
            const data = await localStorage.getItem(keyName)
            if (data) {
                return JSON.parse(data)
            }
            return null
        } catch (error) {
            console.error(`Error retrieving data from localStorage for key "${keyName}":`, error)
            return null
        }
    }

    public static async storeItem<T>(keyName: string, value: T): Promise<void> {
        if (typeof window === 'undefined') {
            return
        }
        try {
            await localStorage.setItem(keyName, JSON.stringify(value))
        } catch (error) {
            console.error(`Failed to store data in localStorage for key "${keyName}":`, error)
        }
    }
}

export default LocalStorageService
